﻿import React from 'react';
import PropTypes from 'prop-types';

export default class Button extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <button
                {...this.props}
                role="button"
                type="button"
                className={`wbm-button btn ${this.props.className}`} 
            >
                {this.props.children}
            </button>
        );
    }
}

Button.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,  
};